import { StarIcon as OutlineStarIcon } from '@heroicons/react/24/outline'
import { StarIcon as SolidStarIcon } from '@heroicons/react/24/solid'
import React from 'react'
import { twMerge } from 'tailwind-merge'

export function ArtistStar({ className = '', isLiked }: { className?: string; isLiked: boolean }) {
  const classNames = twMerge(`h-6 w-6 text-yellow-500`, className)
  return isLiked ? <SolidStarIcon className={classNames} /> : <OutlineStarIcon className={classNames} />
}
